


export default {
    id:"FooMap",
    parent:"Map<Key,Value>",
    type:"class",
    ctor:{
        type:"(entries,options)",
        props:[
            {
                name:"entries",
                type:"Array<[Key,Value]>",
            },
            {
                name:"options",
                type:"object",
                props:[
                    {
                        name:"onChange",
                        type:"():void",
                        notice:"its <b>this</b> points to the current map",
                    },
                ],
            },
        ],
    },
    properties:[
        {
            name:"at",
            type:"(index:Number,isValue:Boolean):Key|Value",
            props:[
                {
                    name:"index",
                    type:"number",
                    description:"used to target the pair at index",
                },
                {
                    name:"isValue",
                    type:"boolean",
                    description:`
                        used to specify if the returned value is a Key or Value type
                        @if true, the value at index  is returned otherwise the key is returned
                        @default to false
                    `,
                }
            ],
        },
        {
            name:"keys",
            type:"():Key[]",
            description:"Returns a frozen array of keys",
        },
        {
            name:"values",
            type:"():Value[]",
            description:"Returns a frozen array of values",
        },
        {
            name:"entries",
            type:"():[Key,Value][]",
            description:"Returns a frozen array of frozen key, value pairs for every entry in the map",
        },
        {
            name:"keyIterator",
            type:"():FooIterator",
            description:"returns a keys iterator",
        },
        {
            name:"valueIterator",
            type:"():FooIterator",
            description:"returns a values iterator",
        },
        {
            name:"entryIterator",
            type:"():FooIterator",
            description:"returns an entries iterator",
            props:[{
                name:"FooIterator",
                props:[
                    {
                        name:"next",
                        type:"():{done:boolean,value:Type|null}",
                        description:"returns the next item in the list",
                    },
                    {
                        name:"current",
                        type:"Type|null",
                        description:"gets the item returned by the last next call",
                    },
                    {
                        name:"currentIndex",
                        type:"number",
                        description:"returns the index of the current item",
                    },
                    {
                        name:"hasNext",
                        type:"boolean",
                        description:"true if the iterator has more items",
                    },
                    {
                        name:"remove",
                        type:"():Type",
                        description:`
                            returns the removed item
                            @throws an error if there is no item to remove
                        `,
                    },
                ],
            }],
        },
        {
            name:"keyIterableIterator",
            type:"():IterableIterator<any>",
            description:"Returns an iterable of keys in the map",
        },
        {
            name:"valueIterableIterator",
            type:"():IterableIterator<any>",
            description:"Returns an iterable of values in the map",
        },
        {
            name:"entryIterableIterator",
            type:"():IterableIterator<any>",
            description:"Returns an iterable of key, value pairs for every entry in the map",
        },
    ],
}